<div class="container-fluid h-100 p-5">
    <div class="m-auto login-panel p-4 col-12 col-xl-4 col-md-6">
        <div class="col">
            <button mat-raised-button color="primary" (click)="doFAMSLoginWithPassword()" i18n>
                Se connecter
            </button>
        </div>
    </div>
</div>